import { gql } from '@apollo/client';

const GET_REPLIES = gql`
  mutation getReplies($commentId: ID!) {
    replies(commentId: $commentId) {
      id
      content
      createdAt
      userId
      postId
      commentId
    }
  }
`;

const ADD_REPLY = gql`
  mutation addReply($content: String!, $postId: ID!, $userId: ID!, $commentId: ID!) {
    addReply(content: $content, postId: $postId, userId: $userId, commentId: $commentId) {
      id
      userId
      content
    }
  }
`;

const UPDATE_REPLY = gql`
  mutation updateReply($id: ID!, $content: String) {
    updateReply(id: $id, content: $content) {
      id
      userId
      content
    }
  }
`;

const DELETE_REPLY = gql`
  mutation deleteReply($id: ID!) {
    deleteReply(id: $id) {
      id
      userId
      content
    }
  }
`;

export { GET_REPLIES, ADD_REPLY, UPDATE_REPLY, DELETE_REPLY }
